<template>
    <div class="mian-contents" >
        <div class="search-box flex">
            <div v-show="isPosition" class="search-box-position">
                <el-select v-model="cityCodes" placeholder="请选择" @change="searchCityCode">
                    <el-option
                        v-for="item in positionArea"
                        :key="item.cityCode"
                        :label="item.cityName"
                        :value="item.cityCode"
                    >
                    </el-option>
                </el-select>
            </div>
            <el-input
                    v-model="name"
                    size="medium"
                    placeholder="搜索职位/公司"
                    @keyup.native.enter="search"
                    style="height: 100%;"
                    class="searchVal">
            </el-input>
            <div class="search-box-btn" @click="search">搜 &nbsp; 索</div>
        </div>
        <div class="search-hot flex itemsCenter" v-if="isHot">
            <p class="shrink">热门职位：</p>
            <div class="search-hot-label flex">
                <div 
                v-for="(item,index) in hotJob" 
                :key="item.positionTypeId" 
                @click="changeValue(item,index)"
                :class="{'active':selectedPosition.includes(item.positionTypeId)}">
                    {{ item.positionTypeName }}
                </div>
            </div>
        </div>
    </div>
  </template>
  <script>
import '../assets/style/index.scss';
import {mapState } from "vuex";
  export default {
    props: {
        isPosition:{
            type:Boolean,
            defaule:false
        },
        isShowHot:{
            type:Boolean,
            defaule:true
        },
        isHot:{
            type:Boolean,
            defaule:true
        },
        keyWords:{
            type:String,
            defaule:''
        },
        widths:{
            type:Number,
            defaule:800
        }
    },
    data(){
        return{
            name:this.keyWords,
            currentHotPosition:'',
            selectedPosition:[],
        }
    },
    created(){},
    components: {},
    computed: {
      ...mapState({
        positionArea:state => state.jobs.positionArea,
        hotJob: state => state.jobs.hotJob, 
        cityCodes:state => state.jobs.cityCodeText,
        currentCityCode:state => state.jobs.currentCityCode, //根据IP地址获取当前的城市code
      }),
    },
   
    methods:{
      searchCityCode(value){
        this.$store.commit("setState",{ key: "cityCodeText", data:value});
        this.$emit("updateCityCode"); 
      },

      search(){
        this.$emit("updateValue",{name:this.name}); 
      },
      changeValue(value,index){
        if(this.selectedPosition.includes(value.positionTypeId)){
            this.selectedPosition=[]
        }else{
            this.selectedPosition=[];
            this.selectedPosition.push(value.positionTypeId)
        }
        this.$emit("updateValue",{positionKind:this.selectedPosition[0]}); 
      },
    },
    // watch:{
    //     positionArea:{
    //         handler(){
    //             if(this.positionArea && this.positionArea.length>0){
    //                 let result = this.positionArea.findIndex(item=>item.cityCode == this.currentCityCode)
    //                 console.log(this.currentCityCode,result,'当前城市code')
    //                 if(result !=  -1){
    //                     this.$store.commit("setState",{ key: "cityCodeText", data:Number(this.currentCityCode)});
    //                     this.$emit("updateCityCode"); 
    //                     console.log(this.cityCodes,888888)
    //                 }

    //             }
    //         },

    //     }
    // }
  };
  </script>
  
  <style lang="less" scoped>
    @mianColor:#287CF3;
    @whiteColor:#fff;
    .mian-contents{
        width: 80%;
        // margin: 0 auto;
        .search-box{
            background: @whiteColor;
            box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
            border-radius: 6px;
            height: 46px;
            border: 1px solid rgba(40, 124, 243, 1);
            margin-bottom: 16px;
            overflow: hidden;
            &-position{
                width: 130px;
                line-height: 46px;
                // padding:0 12px 0 0;
                position: relative;
                // &::after{
                //     content: '';
                //     position: absolute;
                //     right: 0;
                //     bottom: 13px;
                //     width: 1px;
                //     height: 20px;
                //     background-color: #D8D8D8;
                // }
            }
            
            &-btn{
                color: @whiteColor;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                width: 140px;
                text-align: center;
                line-height: 46px;
                cursor: pointer;
                background-color: @mianColor;

            }
            .el-input__inner{
                height: 100%;
                border: none;
            }
        }
        .search-hot{
            align-items: center;
            p{
                margin: 0;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0,0,0,0.85);
                line-height: 22px;
            }
            &-label{
                flex-wrap: wrap;
                div{
                    cursor: pointer;
                    padding: 2px 16px;
                    margin-right: 16px;
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    color: @mianColor;
                    background: rgba(40, 124, 243, .3);
                    border-radius: 12px;
                    margin-bottom: 10px;
                }
                .active{
                    color: #fff;
                    box-shadow: 0 16px 40px 0 hsla(0, 0%, 60%, 0.3);
                }
            }
        }
        /deep/.el-input__inner{
            height: 100% ;
            border: none;
        }
        .dialog-box{
            flex-wrap: wrap;
            p{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0,0,0,0.85);
                padding: 10px;
                cursor: pointer;
            }
        }
        /deep/.el-dialog__body {
            padding: 10px 20px 30px;
        }
    }
    
  </style>
  